{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Nova poruka",
  "chat.scrollToBottom": "Scroll to bottom",
  "messagefeedback.thumbDown": "Loš odgovor",
  "messagefeedback.thumbUp": "Dobar odgovor",
  "promptfield.aiDisclaimer": "Responses are generated using AI, and may be inaccurate. Check before using.",
  "promptfield.aiUserGuidlines": "AI User Guidelines",
  "promptfield.attachments": "Attachments",
  "promptfield.insertButton": "Add",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Spremni za početak? Postavite pitanje, podelite ideju ili dodajte zadatak.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Send",
  "promptfield.uploading": "Uploading",
  "responsestatus.loading": "Učitavanje",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Start recording",
  "voicebutton.stopListening": "Stop recording",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
